import React, { useEffect, useState } from "react";
import "./Shipping.scss";
import { Col, Form, Image, InputGroup, Row } from "react-bootstrap";
import cartLoader from '../../../assets/images/cart_Loader.gif';
import useLoader from "../../../contexts/LoaderContext";
import { useTranslation } from "react-i18next";
interface ShippingOption {
  id: number;
  description: string;
  cost: {
    currency: string;
    value: number;
  };
  costWithDiscount: {
    currency: string;
    value: number;
  };
  formattedCost: string;
  formattedCostWithDiscount?: string;
}
interface ShippingOptionsProps {
  shippingList: {
    shippingOption: ShippingOption[];
  };
  defaultShippingMethodCode?: any; // New prop for the default shipping method code
  validationErrors: Record<string, string>;
  onInputChange: (fieldName: string, value: any) => void; // Callback function for parent component
}
const Shipping: React.FC<ShippingOptionsProps> = ({ shippingList, defaultShippingMethodCode, validationErrors, onInputChange }) => {
  const [shippingOptionsList, setShippingOptionsList] = useState<ShippingOption[] | null>(null);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const { isCartLoading } = useLoader();
  const shippingMethodList = shippingList['shippingOption']
  const { t } = useTranslation();
  useEffect(() => {
    if (shippingMethodList && shippingMethodList.length > 0) {
      setShippingOptionsList(shippingMethodList);
    }
    if (defaultShippingMethodCode !== undefined && defaultShippingMethodCode !== null) {
      setSelectedOption(Number(defaultShippingMethodCode));
    } else {
      setSelectedOption(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultShippingMethodCode, shippingMethodList]);

  const handleShippingMethodChange = (field: string, e: any) => {
    onInputChange(field, Number(e));
    setSelectedOption(Number(e));
  };

  return (
    <div className="ShippingOption">
      {shippingOptionsList && (
        <Row xs={'auto'} md={'auto'} className="shippingDetails mb-4">
          <Col md={12}>
            <h3>{t('SHIPPING_METHOD_TITLE')}</h3>
            <div className={isCartLoading ? `cart-loading` : ''}>
              {isCartLoading && <Image src={cartLoader} className="cartLoader" alt="CartLoader"></Image>}
              <InputGroup className="mb-3 shippingMethod">
                {shippingOptionsList?.map((option: ShippingOption) => (
                  <Form.Group controlId="shippingOption" key={option.id} className="radioGroup">
                    <Form.Check
                      type="radio"
                      name="shippingOption"
                      id={`shippingOption-${option.id}`}
                      value={`${option.id}`}
                      label={
                        <span className="labelWrapper" style={{ 'float': 'left' }}>
                          <span className="radioLabels">
                            <span className="description">{option.description}&#160;</span>
                            <span className="cost">
                              {(option?.formattedCostWithDiscount && option.formattedCost !== option.formattedCostWithDiscount) ? option.formattedCostWithDiscount : option.formattedCost}
                            </span>
                          </span>
                        </span>
                      }
                      checked={selectedOption === option['id']}
                      isInvalid={!!validationErrors.shippingOption}
                      onChange={(e) => handleShippingMethodChange('shippingOption', e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">{validationErrors.shippingOption}</Form.Control.Feedback>
                  </Form.Group>
                ))}
              </InputGroup>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};
export default Shipping;
